const Cookies = require('js-cookie')

export function useFacebookCookies() {
    let timer
    let fbc, fbp

    function appendFacebookCookiesToLinks() {
        timer = setInterval(() => {
            refresh()
            append()
        }, 1000)
    }

    function refresh() {
        fbc = Cookies.get('_fbc') ? Cookies.get('_fbc') : ''
        fbp = Cookies.get('_fbp') ? Cookies.get('_fbp') : ''
    }

    function append() {
        if ( ! fbc && ! fbp) {
            return
        }

        clearInterval(timer)

        let anchors = document.getElementsByTagName('a')

        for (let key in anchors) {
            if (typeof anchors[key].href !== 'string' || ! anchors[key].href instanceof String) {
                continue
            }

            if ( ! anchors[key].href.includes('nutreance.com')) {
                continue
            }

            let url = anchors[key].href.includes('?') ? anchors[key].href.split('?')[0] : anchors[key].href

            switch (true) {
                case !! fbc && !! fbp: {
                    anchors[key].href = `${url}?fbc=${fbc}&fbp=${fbp}`
                    break
                }

                case !! fbc: {
                    anchors[key].href = `${url}?fbc=${fbc}`
                    break
                }

                case !! fbp: {
                    anchors[key].href = `${url}?fbp=${fbp}`
                    break
                }

                default: {
                    break
                }
            }
        }
    }

    return {
        appendFacebookCookiesToLinks,
    }
}